import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltVideoEditorPlayerPreviewLoadingWireframe from './VeltVideoEditorPlayerPreviewLoadingWireframe/VeltVideoEditorPlayerPreviewLoadingWireframe';
import VeltVideoEditorPlayerPreviewVideoWireframe from './VeltVideoEditorPlayerPreviewVideoWireframe/VeltVideoEditorPlayerPreviewVideoWireframe';
var VeltVideoEditorPlayerPreviewWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-preview-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerPreviewWireframe.Loading = VeltVideoEditorPlayerPreviewLoadingWireframe;
VeltVideoEditorPlayerPreviewWireframe.Video = VeltVideoEditorPlayerPreviewVideoWireframe;
export default VeltVideoEditorPlayerPreviewWireframe;
